// @flow

import { connect } from "react-redux";

import { clearAttachment } from "src/actions/email";

import Item from "./Item";

const mapDispatchToProps = {
  removeItem: clearAttachment,
};

export default connect(null, mapDispatchToProps)(Item);
